import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { NovedadesPeriodo } from '../../../../models/novedadesPeriodo';
import { NovedadesPeriodoService } from '../../../../services/novedades-periodo.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-periodo-list',
  templateUrl: './novedades-periodo-list.component.html',
  styleUrls: ['./novedades-periodo-list.component.css']
})
export class NovedadesPeriodoListComponent implements OnInit {

  @Input() personalId: number;
  @Input() novedadesPeriodos: NovedadesPeriodo[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<NovedadesPeriodo>();
    
  novedadesPeriodosOri: NovedadesPeriodo[];
  novedadesPeriodosGrupo: NovedadesPeriodo[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private novedadesPeriodoService: NovedadesPeriodoService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.novedadesPeriodosOri = this.novedadesPeriodos;
    this.inicializaFiltros();
    
    this.filtrarNovedades();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarNovedades()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.novedadesPeriodos = this.novedadesPeriodosOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());    
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.novedadesPeriodosGrupo == undefined)
      {
        this.novedadesPeriodoService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
            });

            this.novedadesPeriodosGrupo = data;
            this.novedadesPeriodos = this.novedadesPeriodosGrupo;
          });

      } else
      {
        this.novedadesPeriodos = this.novedadesPeriodosGrupo;
      }
      
    } else
    {
      this.filtrarNovedades();
    }
  }

  onChangeFiltros()
  {
    this.filtrarNovedades();
  }

  visualizarDetalle(novedadPeriodo)
  {
    this.VisualizarDetalle.emit(novedadPeriodo);
  }

  add()
  {
    let novedadPeriodo: NovedadesPeriodo = { id: 0, personal: this.personalId, desde: new Date().toString(), hasta: new Date("2999-12-31T23:59:59").toString(), cantidad: 0, importe: 0, moneda: 1, motivo: "", unidadMedida: "" };
    this.VisualizarDetalle.emit(novedadPeriodo);
  }
}
